import React from 'react';
import { IAuditoriaAdiantamentoClientesResultado } from '../interfaces/IAuditoriaAdiantamentoClientes';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAdiantamentoClientesResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Passivo por Adiantamentos de Clientes — não é um tributo, é uma
// auditoria complementar que verifica se contas de Adiantamento de Clientes (Passivo Circulante)
// foram baixadas (NF emitida) dentro de 30 dias. Segue o mesmo padrão de seção própria já usado
// para os outros módulos de auditoria.
const AuditoriaResumoAdiantamentoClientes: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.adiantamentosEstagnados?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Passivo — Adiantamentos de Clientes</h3>
      <p className='text-muted'>
        Auditoria complementar — adiantamentos de clientes (Passivo Circulante) sem baixa por mais de 30 dias configuram
        presunção de receita disponível (CPC 47 / IFRS 15 + Art. 27 da Lei 10.833/2003). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ADIANTAMENTO_CLIENTES')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Adiantamentos de Clientes (Passivo)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} adiantamento{totalOcorrencias === 1 ? '' : 's'} estagnado{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Tributos por regime + Multa ECD potencial (5% limitada a 1% da receita bruta — Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAdiantamentoClientes;
